import React from 'react';
import image from '../../assets/images/web-design.png'

const ServicesCard = ({title,description}) => {

    return (
        <div className='bg-bgPrimary rounded p-6 flex gap-5 justify-center' >
            <img className='h-12 mt-2' src={image} alt="" />
           
<div className='texts'>
<h2 className='font-bold text-2xl uppercase'>{title}</h2>
           <p className='text-secondaryWhite mt-6 text-justify'>{description}</p>
</div>

        </div>
    );
};

export default ServicesCard;